







import {Component, Vue} from 'vue-property-decorator';
import {Stored} from 'vue-stored-prop-decorator';
import {Game} from '@/models';
import gameStore from '@/stores/modules/game';

@Component
export default class Home extends Vue {
	
	@Stored(gameStore)
	public game: Game;
	
	public mounted(): void {
		if (this.game.started) {
			this.$router.push({ name: 'start' });
		} else {
			this.$router.push({ name: 'create' });
		}
	}
}

